import LoseUserDist from './LoseUserDist';

export default LoseUserDist;
